@if (shouldRenderTrigger) {
  <div class="task-attachments">
    <input #fileInput class="hidden" type="file" multiple (change)="handleAttachmentSelection($event)"/>

    <button
      (click)="toggleMenu($event)"
      [class.outline]="mode === 'chip'"
      [class.btn]="mode === 'button'"
      [class.btn-neutral-outline]="mode === 'button'"
      [disabled]="isUploading"
      class="task-attachments-trigger cd-text-b4 flex flex-row gap-1 items-center w-fit"
      type="button">
      <img
        [alt]="isUploading ? 'Adjuntando' : 'Adjuntos'"
        [class.loader-icon]="isUploading"
        [class.animate-spin]="isUploading"
        class="filter-neutral-600 h-4"
        [src]="isUploading ? '/assets/icons/feather/loader.svg' : '/assets/icons/feather/paperclip.svg'">
      <span class="truncate">{{ triggerLabel }}</span>
    </button>

    @if (mode === 'chip' && isOpen) {
      <div (click)="$event.stopPropagation()" class="task-attachments-panel shadow-e1">
        <div class="task-attachments-panel-header">
          <span class="cd-text-b4 font-medium">Adjuntos</span>
          @if (allowUpload) {
            <button (click)="openUploader($event)" class="btn btn-neutral-text !px-1 !py-1 ml-auto" type="button">
              <img alt="Agregar" class="filter-neutral-800 h-4" src="/assets/icons/feather/upload.svg">
            </button>
          }
        </div>

        @if (isUploading) {
          <div class="task-attachments-empty">Subiendo adjuntos...</div>
        } @else if (errorMessage) {
          <div class="task-attachments-error">{{ errorMessage }}</div>
        } @else if (attachments.length) {
          <div class="task-attachments-list">
            @for (file of attachments; track file.id) {
              <core-file-widget
                class="border border-neutral-300 bg-white"
                [fileName]="file.fileName"
                [fileSize]="formatFileSize(file.fileSize)"
                [showRemove]="allowUpload"
                [showDownload]="true"
                [showActions]="!isDeletingAttachment(file.id)"
                (download)="downloadAttachment(file)"
                (remove)="removeAttachment(file)"/>
            }
          </div>
        } @else {
          <div class="task-attachments-empty">Sin documentos adjuntos.</div>
        }
      </div>
    }
  </div>
}

@if (showInlineList) {
  <div class="task-attachments-inline">
    @if (errorMessage) {
      <div class="task-attachments-error">{{ errorMessage }}</div>
    } @else if (attachments.length) {
      <div class="task-attachments-list">
        @for (file of attachments; track file.id) {
          <core-file-widget
            class="border border-neutral-300 bg-white"
            [fileName]="file.fileName"
            [fileSize]="formatFileSize(file.fileSize)"
            [showRemove]="allowUpload"
            [showDownload]="true"
            [showActions]="!isDeletingAttachment(file.id)"
            (download)="downloadAttachment(file)"
            (remove)="removeAttachment(file)"/>
        }
      </div>
    }
  </div>
}
